import { useRouter } from 'next/navigation'
import { ArrowLeft } from 'lucide-react'

import { SheetClose } from '@rewardops/ui'

import { NavigationLink } from '~/context/resources-provider'
import { MenuLinkProps } from './desktop-menu-link'

type MobileMenuLinkProps = MenuLinkProps & { onClick: () => void }

const MobileMenuLink: React.FC<MobileMenuLinkProps> = ({
  menu,
  onClick,
}: MobileMenuLinkProps) => {
  const { push } = useRouter()

  const handleClick = (link: NavigationLink) => {
    if (link?.isRelativeUrl == false) {
      onClick()
      return window?.open(link?.to, '_blank')
    }

    push(link?.to)
    onClick()
  }

  return (
    <>
      <div className="flex flex-row items-center border-b p-4">
        <SheetClose asChild>
          <ArrowLeft className="h-6 w-6" />
        </SheetClose>
        <div
          id="shop-categories"
          className="flex w-full items-center justify-center py-1 text-lg font-semibold"
        >
          {menu.name}
        </div>
      </div>
      <div>
        {menu?.links.map((link) => (
          <>
            <div id={link?.id} key={link?.id} onClick={() => handleClick(link)}>
              <div className="cursor-pointer px-2 py-4 text-sm font-semibold decoration-2 hover:text-tenant-primary-color hover:underline hover:underline-offset-4">
                {link?.name}
              </div>
            </div>
            <hr />
          </>
        ))}
      </div>
    </>
  )
}

export { MobileMenuLink }
